import { Link, Route, Routes } from "react-router-dom";
import { PRODUCT } from "@word-duel/shared/config";
import { AppShell } from "./components/ui";
import { GameScreen } from "./screens/GameScreen";
import { JoinScreen } from "./screens/JoinScreen";
import { LandingScreen } from "./screens/LandingScreen";

function NotFoundScreen() {
  return (
    <AppShell>
      <main className="page page--narrow error-page">
        <p className="eyebrow">404 / WRONG TURN</p>
        <h1>That square is empty.</h1>
        <p>
          The page you followed does not exist. Your locally saved games are still on this device.
        </p>
        <Link className="button button--primary" to="/">
          Back to {PRODUCT.shortName}
        </Link>
      </main>
    </AppShell>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingScreen />} />
      <Route path="/join" element={<JoinScreen />} />
      <Route path="/join/:code" element={<JoinScreen />} />
      <Route path="/game/:code" element={<GameScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}
